import { useEffect } from 'react';

interface HoneypotProps {
  value: string;
  onChange: (value: string) => void;
  name?: string;
}

export const Honeypot = ({ value, onChange, name = "website" }: HoneypotProps) => {
  // Prevent browser autofill
  useEffect(() => {
    const timer = setTimeout(() => {
      const input = document.querySelector(`input[name="${name}"]`) as HTMLInputElement;
      if (input && input.value !== value) {
        onChange(input.value);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [name, value, onChange]);

  return (
    <div 
      style={{ 
        position: 'absolute',
        left: '-9999px',
        top: '-9999px',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
        display: 'none'
      }}
      aria-hidden="true"
      tabIndex={-1}
    >
      <label htmlFor={`${name}-honeypot`} style={{ display: 'none' }}>
        Leave this field empty
      </label>
      <input
        id={`${name}-honeypot`}
        name={name}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete="off"
        tabIndex={-1}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export default Honeypot;